// Session handoff from web3kurzus.hu — step 1: take the tokens off the URL.
//
// The landing opens this app as
//   /tanfolyamok#w3k_handoff=1&w3k_at=<access_token>&w3k_rt=<refresh_token>
// (same format as the terminal → landing handoff; see the landing repo's
// src/sessionHandoff.js and src/egyetem.js). The `w3k_` keys keep supabase-js
// from mistaking it for its own implicit-grant callback.
//
// This module has NO imports and is the first import in src/index.js, so the
// hash is read and removed from the address bar before the router, the
// Supabase client or anything else runs. The tokens then live only in this
// module until sessionHandoff.js uses them. Never log them.

let captured = null;

function capture() {
  let hash = window.location.hash || '';
  if (hash.startsWith('#')) hash = hash.slice(1);
  if (!hash) return;

  const params = new URLSearchParams(hash);
  if (params.get('w3k_handoff') !== '1') return;

  // Remove the tokens from the address bar first, on every path — a token
  // left there could be bookmarked or shared.
  try {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  } catch (e) { /* ignore */ }

  const access_token = params.get('w3k_at');
  const refresh_token = params.get('w3k_rt');
  if (access_token && refresh_token) captured = { access_token, refresh_token };
}

capture();

// Returns the captured tokens once; later calls get null.
export function takeHandoff() {
  const h = captured;
  captured = null;
  return h;
}
